var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificateSelfSigned = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m17.694 10.365 3.409 3.409-7.972 7.972a.88.88 0 0 1-.636.263h-2.127a.912.912 0 0 1-.91-.909v-2.127c0-.245.1-.472.264-.645l7.972-7.963Zm4.382 2.436-3.41-3.408 1.664-1.664a.905.905 0 0 1 1.282 0l2.127 2.127a.905.905 0 0 1 0 1.282L22.076 12.8Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  x: 8.005,
  y: 23.557,
  fill: "currentColor",
  rx: 1
})));
export default SvgCertificateSelfSigned;